import { z } from 'zod';

import { assetSchema } from './assetSchema';
import { caseSelectorItemOverrideSchema } from './caseSelectorItemOverrideSchema';
import { IDisclaimerSchema } from './disclaimerTypes/disclaimerSchema';
import { masterClassSchema } from './masterclassSchema';
import { slideSchema } from './slideTypes/slideSchema';
import { variationSchema } from './variationSchema';

export const patientCaseContentSchema = z.object({
  id: z.string(),

  displayName: z.string(),
  path: z.string(),
  slides: z.array(slideSchema),
  assets: z.array(assetSchema),
  variations: z.array(variationSchema),
  language: z.string(),

  //Optional
  name: z.string().optional(),
  disclaimer: IDisclaimerSchema.optional(),
  // NOTE: the purpose of these two client fields is for the masterclass mainly, if
  // these are set, we will replace our logo with the client's logo and it will redirect to their website.
  clientLogoPath: z.string().optional(),
  clientLogoRedirectUrl: z.string().optional(),
  caseSelectorItemOverride: caseSelectorItemOverrideSchema.optional(),
  masterclass: masterClassSchema.optional(),
}).strict();

export type PatientCaseContent = z.infer<typeof patientCaseContentSchema>;

export const unloadedIPatientCaseSchema = z.object({
  id: z.string(),
  name: z.string(),
  path: z.string(),
  purchaseOrder: z.string(),
  creationDate: z.string(),
  clientName: z
    .string()
    .regex(/^[a-z-]+$/, "Must only contain lowercase letters and '-'")
    .refine((value) => !value.includes(' '), {
      message: 'Cannot contain spaces',
    }),
});

export type UnloadedIPatientCase = z.infer<typeof unloadedIPatientCaseSchema>;
